import * as types from "./actionType";
import {
    getLandlord,
    getRider,
    getProperty,
    getClaimId,
    getContentVersion,
    checkPolicyDuplicated
} from '../apis/axios'

export const setDataAction = (data) => ({
      type: types.SET_DATA,
      payload: data,
});

export const setInitiateAction = () => ({
    type: types.SET_INITIATE
})

export const setLandlordArrayAction = (data) => ({
    type: types.SET_LANDLORD_ARRAY,
    payload: data,
});

const setClaimIdAction = (data) => ({
    type: types.SET_CLAIMID,
    payload: data
})

const setAgreementIdAction = (data) => ({
    type: types.SET_AGREEMENTID,
    payload: data
})

const setLedgerIdAction = (data) => ({
    type: types.SET_LEDGERID,
    payload: data
})

export const setErrorAction = (data) => ({
    type: types.SET_ERR,
    payload: data
})

export const setResultAction = (data) => ({
    type: types.SET_RESULT,
    payload: data
})

export const getLandlordAction = () => {
    return (dispatch) => {
        getLandlord()
        .then((res) => {
            dispatch(setLandlordArrayAction(res));
        })
        .catch((err) => {
            console.log(err)
            dispatch(setErrorAction(err.response.data.message));
        })
    }
}

export const setApartmentArrayAction = (data) => ({
    type: types.SET_APARTMENT_ARRAY,
    payload: data,
});

export const getApartmentAction = (data) => {
    return (dispatch) => {
        getProperty(data)
        .then((res) => {
            dispatch(setApartmentArrayAction(res));
        })
        .catch((err) => {
            console.log(err)
            dispatch(setErrorAction(err.response.data.message));
        })
    }
}

export const setRiderArrayAction = (data) => ({
    type: types.SET_RIDER_ARRAY,
    payload: data,
});

export const getRiderAction = (data) => {
    return (dispatch) => {
        getRider(data)
        .then((res) => {
            dispatch(setRiderArrayAction(res));
        })
        .catch((err) => {
            console.log(err)
            dispatch(setErrorAction(err.response.data.message));
        })
    }
}

export const createClaimAction = (data) => {

    return async (dispatch) => {
        const {leaseFile, ledgerFile, otherFiles, ...claimData} = data;
        const formData = new FormData();
        formData.append('claimData', JSON.stringify(claimData));
        formData.append('files', ledgerFile, `Lease Agreement Document.${ledgerFile.path.split('.')[1]}`);
        formData.append('files', leaseFile, `Resident Ledger Document.${leaseFile.path.split('.')[1]}`);
        for(const otherFile of otherFiles) {
            formData.append('files', otherFile, otherFile.path);
        }
        try {
            dispatch(setResultAction({status: 'pending'}));
            const res = await getClaimId(formData);
            dispatch(setClaimIdAction(res.name));
            dispatch(setResultAction({status: 'success'}));
        } catch (error) {
            dispatch(setResultAction({status: 'failed', message:error.response.data.message, data: error.response.data.data}));
            console.log(error);
        }
    }
}

export const setpolicyDuplicatedAction = (data) => ({
    type: types.SET_POLICY_DUPLICATED,
    payload: data
})

export const checkPolicyDuplicatedAction = (data) => {
    return async (dispatch) => {
        try {
            dispatch(setpolicyDuplicatedAction(null));
            const res = await checkPolicyDuplicated(data);
            dispatch(setpolicyDuplicatedAction(res));

        } catch (error) {
            dispatch(setErrorAction(error.response.data.message));
            console.log(error);
        }
    }
}
